import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/layout/ThemeProvider";

/** Avisos curtos (toast) no tema atual; no celular ficam acima da barra inferior. */
export function Toaster() {
  const { resolved } = useTheme();
  return (
    <Sonner
      theme={resolved}
      position="bottom-center"
      offset={{ bottom: 24 }}
      mobileOffset={{ bottom: 104 }}
      toastOptions={{
        classNames: {
          toast: "!rounded-chip !border-border !bg-surface !text-ink !shadow-float",
          actionButton: "!bg-accent !text-accent-ink !font-semibold",
        },
      }}
    />
  );
}
